<mat-radio-group [formControl]="interestOriginControl">
  <div class="update-option">
    <mat-radio-button [value]="USER_ORIGIN">
      {{ whitelabelBusinessCenterName$ | async }}
    </mat-radio-button>
  </div>
  <div class="update-option">
    <mat-radio-button [value]="EMAIL_ORIGIN">
      {{ 'AUTOMATIONS.EDITOR.TRIGGERS.CUSTOMER_VIEWS_PACKAGE.ORIGIN.PUBLIC_STORE' | translate }}
    </mat-radio-button>
  </div>
</mat-radio-group>
